export { default } from '@framework/tenant/config/tenantEvercall';
